import React from 'react'
import Nav from "../Global/Nav"
import Footer from "../Global/Footer"
import ProfileHero from './ProfileHero'

const ProfilePage = () => {
  return (
    <>
    <Nav />
    <ProfileHero />
    <Footer />
    </>
  )
}

export default ProfilePage